import { render, staticRenderFns } from "./data-transfer-minimization-status.vue?vue&type=template&id=2c635d7b"
import script from "./data-transfer-minimization-status.vue?vue&type=script&lang=js"
export * from "./data-transfer-minimization-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports